module.exports = __webpack_public_path__ + "static/media/logo.ed823c75.png";